import { render } from "./403Error.vue?vue&type=template&id=2bce513d&scoped=true"
import script from "./403Error.vue?vue&type=script&lang=js"
export * from "./403Error.vue?vue&type=script&lang=js"

import "./403Error.vue?vue&type=style&index=0&id=2bce513d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bce513d"]])

export default __exports__